<template>
    <svg :width="width" :height="height">
      <path
        :d="path"
        class="line"
        fill="none"
        stroke-width="1"
        stroke="black"
      />
      <circle
        v-if="highlight"
        :r="2.5"
        :cx="highlight_x"
        :cy="highlight_y"
        fill="white"
        stroke="black"
      />
    </svg>
</template>

<script>
import * as d3 from 'd3'
import {largestTriangleThreeBucket} from 'd3fc-sample';


export default {

  name: 'SparkLine',
  props: {
    highlight: Number,
    data: Array,
    width: { default: 50, type: Number },
    height: { default: 20, type: Number },
  },

  data: function() {
    return {
      sampler: largestTriangleThreeBucket(),
      margin_y: 3,
      margin_x: 3
    }
  },

  computed: {

    bucketSize() {
      return Math.round((2 * this.data.length)/this.width);
    },

    highlight_x() {
      return this.scale_x( this.highlight/this.bucketSize )
    },

    highlight_y() {
      return this.scale_y( this.buckets[Math.round(this.highlight/this.bucketSize)] )
    },

    buckets() {
      return this.sampler.bucketSize(this.bucketSize)(this.data)
    },

    scale_x () {
      return  d3.scaleTime()
        .range([this.margin_x, this.width - this.margin_x])
        .domain([0, this.buckets.length]);
    },

    scale_y () {
      return  d3.scaleLinear()
        .range([this.height - this.margin_y, this.margin_y])
        .domain(d3.extent(this.data))
    },

    path: function () {
      var self = this;
      return  d3.line()
        .x(function(d,i) { return self.scale_x(i); })
        .y(function(d) {  return self.scale_y(d); })(self.buckets)
    },
  },

  watch:  {
     day: function() {
    //
    }
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#map {
  padding:0;margin:0;
  height: 100%;
  width: 100%;
}
svg { margin-top:10px}

</style>
